export default __webpack_public_path__ + "static/media/implementation.1b2a9140.png";